
import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { AxiosInitializer } from '../../AxiosInitializer';
import { useAgeReadyContext } from "../../AgeReadyContext/AgeReadyContext";
import { Loader } from "semantic-ui-react";
import Auth from "@aws-amplify/auth";

interface UserInitializerProps {
  setIsInitialized: (value: boolean) => void;
}
export const UserInitializer: React.FC<UserInitializerProps> = observer((props) => {
  const { setIsInitialized } = props;
  const [isInitializing, setIsInitializing] = useState(false);
  const { caregiverStore } = useAgeReadyContext();

  useEffect(() => {
    if (!isInitializing) {
      setIsInitializing(true);
      AxiosInitializer().then(() => {
        // I think this may need to be load user in the future.
        return Auth.currentAuthenticatedUser();
      })
        .then((currentUserInfo) => {
          caregiverStore.logout();
          return caregiverStore.loadForCargiverId(currentUserInfo.username);
        }).then(() => {
          setIsInitialized(true);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <Loader active />
});

